import {ReactComponentWidget} from './react-component'

export type UploadPlaceholderWidgetProps = {
  fileName: string
  progressPercent?: number
  previewUrl?: string
  mediaKind?: 'image' | 'video'
  dimensions?: {width: number; height: number}
  active?: boolean
}

export class UploadPlaceholderWidget extends ReactComponentWidget<UploadPlaceholderWidgetProps> {
  static widgetName = 'upload-placeholder-widget'

  constructor(id: string, props: UploadPlaceholderWidgetProps) {
    super(UploadPlaceholderWidget.widgetName, id, props)
  }
}
